var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{staticClass:"settings",on:{"submit":function($event){$event.preventDefault();return _vm.send.apply(null, arguments)}}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings__body"},[_c('div',{staticClass:"app-form"},[_c('div',{staticClass:"app-form__header"},[_vm._v("Сессия")]),_c('div',{staticClass:"app-form__content"},[_c('div',{staticClass:"settings__descr"})])])])
}]

export { render, staticRenderFns }